import useAuth from "~/hooks/auth/useAuth";
import useFeatureFlags from "~/hooks/useFeatureFlags";
import usePagination from "~/hooks/usePagination";
import type { SigningSubmission } from "~/types/collections";

export default function useActionRequiredDocumentCount(): {
  count: number;
  isLoading: boolean;
} {
  const { user } = useAuth();
  const { data: featureFlags } = useFeatureFlags();

  const userEmail = user?.email || "";
  const isLandlord = user?.internalRole === "landlord";
  const enabled = Boolean(featureFlags?.signing && (!isLandlord || userEmail));

  const where = enabled
    ? {
        status: { equals: "pending" },
        "submitters.status": { in: ["sent"] },
        "submitters.contact": { equals: user?.contactId || "" },
      }
    : undefined;

  const { data, isLoading } = usePagination<SigningSubmission>({
    collection: "signing-submissions",
    limit: 100,
    depth: 0,
    where,
    serialLoading: !enabled,
  });

  if (!enabled) return { count: 0, isLoading: false };

  return { count: data?.length ?? 0, isLoading };
}
